// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Avatar-cls1___7cd758c57cfe85d1cbf{/*!*/}.Avatar-cls2___ea460dbb01ca127dbf4{font-size:16px;font-weight:700;line-height:20px;-webkit-font-smoothing:antialiased}.Avatar-cls2___ea460dbb01ca127dbf4:not(:hover){text-decoration:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "Avatar-cls1___7cd758c57cfe85d1cbf",
	"cls2": "Avatar-cls2___ea460dbb01ca127dbf4 Avatar-cls1___7cd758c57cfe85d1cbf"
};
export default ___CSS_LOADER_EXPORT___;
